<div class="row pt-4 mb-5">
    <form role="form" [formGroup]="formCandidatura" (ngSubmit)="onSubmit()" class="w-100">
        <div class="col-md-6">
            <div class="card p-3 mb-4 h-100">
                <!--<div *ngIf="carregandoCandidatosEdit == true" class="carregando">
                        <div class="c-loader"></div>
                    </div> -->
                <h5 *ngIf="!editando" class="mb-0">Parametrização Candidatura</h5>
                <h5 *ngIf="editando" class="mb-0">Editar Candidatura</h5>
                <hr>

                <div class="col-12">
                    <div class="row m-0">
                        <strong>Data Hora Início *</strong>
                    </div>
                    <div class="row m-0">
                        <input class="form-control ext-input p-8" type="datetime-local" min="2000-01-01T00:00"
                            max="2100-12-31T00:00" placeholder="dd/MM/aaaa"
                            formControlName="dataHoraInicioCandidaturas">
                        <span class="alert alert-danger mr-2 ml-2 mt-n1
                                p-1" *ngIf="!formCandidatura.get('dataHoraInicioCandidaturas').valid
                                && ( formCandidatura.get('dataHoraInicioCandidaturas').touched
                                || isSubmit )">
                            <small>Campo data e hora início é
                                obrigatório!</small>
                        </span>
                        <span class="alert alert-danger mr-2 ml-2 mt-n1
                                p-1" *ngIf="formCandidatura.get('dataHoraInicioCandidaturas').valid
                                &&
                                !this.validaData(formCandidatura.get('dataHoraInicioCandidaturas').value)
                                && ( formCandidatura.get('dataHoraInicioCandidaturas').touched
                                || isSubmit )">
                            <small>A data precisa ser no futuro!</small>
                        </span>
                    </div>
                </div>
                <div class="col-12">
                    <div class="row m-0">
                        <strong>Data Hora Fim *</strong>
                    </div>
                    <div class="row m-0">
                        <input class="form-control ext-input p-8" type="datetime-local" min="2000-01-01T00:00"
                            max="2100-12-31T00:00" placeholder="dd/MM/aaaa" formControlName="dataHoraFimCandidaturas">
                        <span class="alert alert-danger mr-2 ml-2 mt-n1
                                p-1" *ngIf="!formCandidatura.get('dataHoraFimCandidaturas').valid
                                && ( formCandidatura.get('dataHoraFimCandidaturas').touched ||
                                isSubmit )">
                            <small>Campo data e hora fim é obrigatório!</small>
                        </span>
                        <span class="alert alert-danger mr-2 ml-2 mt-n1
                                p-1" *ngIf="formCandidatura.get('dataHoraFimCandidaturas').valid &&
                                !this.validaData(formCandidatura.get('dataHoraFimCandidaturas').value)
                                && !formCandidatura.get('dataHoraInicioCandidaturas').value
                                && ( formCandidatura.get('dataHoraFimCandidaturas').touched ||
                                isSubmit )">
                            <small>A data precisa ser no futuro!</small>
                        </span>
                        <span class="alert alert-danger mr-2 ml-2 mt-n1
                                p-1" *ngIf="formCandidatura.get('dataHoraFimCandidaturas').valid &&
                                !this.validaData()
                                && formCandidatura.get('dataHoraInicioCandidaturas').value
                                && ( formCandidatura.get('dataHoraFimCandidaturas').touched ||
                                isSubmit )">
                            <small>A data fim precisa ser posterior ao
                                inicio!</small>
                        </span>
                    </div>
                </div>

            </div>
        </div>
        <div class="col-md-6">
            <div class="card p-3 mb-4 h-100">
                <!--<div *ngIf="carregandoCandidatosEdit == true" class="carregando">
                        <div class="c-loader"></div>
                    </div> -->
                <h5 *ngIf="!editando" class="mb-0">Parametrização Aprovação de Candidaturas</h5>
                <h5 *ngIf="editando" class="mb-0">Editar Aprovação de Candidaturas</h5>
                <hr>

                <div class="col-12">
                    <div class="row m-0">
                        <strong>Data Hora Início *</strong>
                    </div>
                    <div class="row m-0">
                        <input class="form-control ext-input p-8" type="datetime-local" min="2000-01-01T00:00"
                            max="2100-12-31T00:00" placeholder="dd/MM/aaaa"
                            formControlName="dataHoraInicioAprovacao">
                        <span class="alert alert-danger mr-2 ml-2 mt-n1
                                p-1" *ngIf="!formCandidatura.get('dataHoraInicioAprovacao').valid
                                && ( formCandidatura.get('dataHoraInicioAprovacao').touched
                                || isSubmit )">
                            <small>Campo data e hora início é
                                obrigatório!</small>
                        </span>
                        <span class="alert alert-danger mr-2 ml-2 mt-n1
                                p-1" *ngIf="formCandidatura.get('dataHoraInicioAprovacao').valid
                                &&
                                !this.validaData(formCandidatura.get('dataHoraInicioAprovacao').value)
                                && ( formCandidatura.get('dataHoraInicioAprovacao').touched
                                || isSubmit )">
                            <small>A data precisa ser no futuro!</small>
                        </span>
                        <span class="alert alert-danger mr-2 ml-2 mt-n1
                                p-1" *ngIf="formCandidatura.get('dataHoraInicioAprovacao').valid &&
                                !this.validaAprovacaoAposCandidatura()
                                && formCandidatura.get('dataHoraFimCandidaturas').value
                                && ( formCandidatura.get('dataHoraInicioAprovacao').touched ||
                                isSubmit )">
                            <small>A data de início da aprovação deve ser posterior a data fim das candidaturas!</small>
                        </span>
                    </div>
                </div>
                <div class="col-12">
                    <div class="row m-0">
                        <strong>Data Hora Fim *</strong>
                    </div>
                    <div class="row m-0">
                        <input class="form-control ext-input p-8" type="datetime-local" min="2000-01-01T00:00"
                            max="2100-12-31T00:00" placeholder="dd/MM/aaaa" formControlName="dataHoraFimAprovacao">
                        <span class="alert alert-danger mr-2 ml-2 mt-n1
                                p-1" *ngIf="!formCandidatura.get('dataHoraFimAprovacao').valid
                                && ( formCandidatura.get('dataHoraFimAprovacao').touched ||
                                isSubmit )">
                            <small>Campo data e hora fim é obrigatório!</small>
                        </span>
                        <span class="alert alert-danger mr-2 ml-2 mt-n1
                                p-1" *ngIf="formCandidatura.get('dataHoraFimAprovacao').valid &&
                                !this.validaData(formCandidatura.get('dataHoraFimAprovacao').value)
                                && !formCandidatura.get('dataHoraInicioAprovacao').value
                                && ( formCandidatura.get('dataHoraFimAprovacao').touched ||
                                isSubmit )">
                            <small>A data precisa ser no futuro!</small>
                        </span>
                        <span class="alert alert-danger mr-2 ml-2 mt-n1
                                p-1" *ngIf="formCandidatura.get('dataHoraFimAprovacao').valid &&
                                !this.validaDataAprovacao()
                                && formCandidatura.get('dataHoraInicioAprovacao').value
                                && ( formCandidatura.get('dataHoraFimAprovacao').touched ||
                                isSubmit )">
                            <small>A data fim precisa ser posterior ao
                                inicio!</small>
                        </span>
                        <span class="alert alert-danger mr-2 ml-2 mt-n1
                                p-1" *ngIf="formCandidatura.get('dataHoraFimAprovacao').valid &&
                                !this.validaAprovacaoAntesEleicao()
                                && ( formCandidatura.get('dataHoraFimAprovacao').touched ||
                                isSubmit )">
                            <small>A data fim precisa ser anterior ao início da eleição!</small>
                        </span>
                    </div>
                </div>

            </div>
        </div>

        <div class="col-6">
            <button type="submit" class="btn btn-success btn-custom w-100" [disabled]="btOff">Salvar</button>
        </div>
    </form>
</div>

